import axios, { AxiosHeaders, type AxiosInstance, type InternalAxiosRequestConfig } from 'axios'

const baseAPIUrl = `${import.meta.env.VITE_BASE_API_ORIGIN}${import.meta.env.VITE_BASE_API_PATH}`
const API_BASE_URLS = [baseAPIUrl, import.meta.env.VITE_BOARD_LIVE_API_URL]
const IGNORE_INTERCEPT = ['/auth/login', '/auth/signup']
export class HttpClient {
    axios: AxiosInstance

    constructor(baseUrl?: string) {
        this.axios = axios.create({ baseURL: baseUrl || API_BASE_URLS[0], withCredentials: true })

        // Intercept every requests and add the token to the header
        this.axios.interceptors.request.use(
            async value => {
                try {
                    // Only for the API
                    if (!API_BASE_URLS.includes(value.baseURL)) return await Promise.resolve(value)

                    // Ignore some requests
                    if (value.url && IGNORE_INTERCEPT.includes(value.url)) return await Promise.resolve(value)

                    const requestConfig: InternalAxiosRequestConfig<any> = {
                        ...value,
                        headers: new AxiosHeaders({
                            'Content-Type': 'application/json',
                            ...value.headers
                        })
                    }

                    return requestConfig
                } catch (e) {
                    return await Promise.reject(e)
                }
            },
            error => {
                Promise.reject(error)
            }
        )
    }
}
export const httpClient = new HttpClient()
export const boardLiveHttpClient = new HttpClient(import.meta.env.VITE_BOARD_LIVE_API_URL)
